export function checkWinScore(
    score: number[] | undefined,
    sideToCheck: number
) {
    return !score ? false :
        score[sideToCheck as number] > score[sideToCheck == 0 ? 1 : 0]
}